import { toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = {
  key: 4,
  class: "p-grid"
}
const _hoisted_6 = { class: "content p-grid" }
const _hoisted_7 = { class: "p-col-12" }
const _hoisted_8 = { class: "p-grid" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-8" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Onboarding")
], -1)
const _hoisted_10 = { class: "p-col-4 p-text-center" }
const _hoisted_11 = {
  key: 0,
  class: "pi pi-check text-green-brain",
  style: {"font-size":"1.25rem"}
}
const _hoisted_12 = {
  key: 1,
  class: "pi pi-clock text-red-brain",
  style: {"font-size":"1.25rem"}
}
const _hoisted_13 = {
  key: 5,
  class: ""
}
const _hoisted_14 = { class: "content p-grid" }
const _hoisted_15 = { class: "p-col-12" }
const _hoisted_16 = { class: "p-grid" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-4 p-d-flex p-ai-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Kick-Off")
], -1)
const _hoisted_18 = { class: "p-col-8" }
const _hoisted_19 = { class: "p-col-12" }
const _hoisted_20 = { class: "p-grid" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-4 p-d-flex p-ai-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, "WarmUp")
], -1)
const _hoisted_22 = { class: "p-col-8" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" No hay Profesores ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_OnboardingSelector = _resolveComponent("OnboardingSelector")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createTextVNode(_toDisplayString(_ctx.showCol) + " ", 1),
    _createVNode(_component_DataTable, {
      value: _ctx.staffTracing.data
    }, {
      empty: _withCtx(() => [
        _hoisted_23
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
          return (_openBlock(), _createBlock(_component_Column, {
            key: col.field,
            field: col.field,
            header: col.header,
            hidden: !_ctx.showCol.includes(col.header),
            style: _normalizeStyle([col.field === _ctx.ColumnFields.OnboardingStages && 'width: 400px'])
          }, {
            body: _withCtx(({ data }) => [
              (col.field === _ctx.ColumnFields.Person)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("span", null, _toDisplayString(data.userInfo.profile ? `${data.userInfo.profile.firstName} ${data.userInfo.profile.lastName}` : '--'), 1)
                  ]))
                : _createCommentVNode("", true),
              (col.field === _ctx.ColumnFields.CoursePlan)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("span", null, _toDisplayString(data.levelInfo? data.levelInfo.title : '--'), 1)
                  ]))
                : _createCommentVNode("", true),
              (col.field === _ctx.ColumnFields.Course)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(data.camadaInfo? data.camadaInfo.id : '--'), 1)
                  ]))
                : _createCommentVNode("", true),
              (col.field === _ctx.ColumnFields.AfiliationDate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(data.assignationDate, 'dd/MM/yyyy')), 1)
                  ]))
                : _createCommentVNode("", true),
              (col.field === _ctx.ColumnFields.OnboardingVideos)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _hoisted_9,
                          _createElementVNode("div", _hoisted_10, [
                            (data.onboardingStage === _ctx.OnBoardingStage.VIEWED)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                              : (_openBlock(), _createElementBlock("i", _hoisted_12))
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (col.field === _ctx.ColumnFields.OnboardingStages)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _hoisted_17,
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_Calendar, {
                              fullWidth: "",
                              disabled: (data.kickOffDate === undefined || null) ? false: true,
                              showTime: false,
                              dateFormat: "dd/mm/yy",
                              onDateSelect: ($event: any) => (_ctx.changeKickOff(data, $event)),
                              modelValue: data.kickOffDate,
                              "onUpdate:modelValue": ($event: any) => (data.kickOffDate = $event)
                            }, null, 8, ["disabled", "onDateSelect", "modelValue", "onUpdate:modelValue"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", null, [
                              _createVNode(_component_OnboardingSelector, {
                                onChange: ($event: any) => (_ctx.changeWarmUp(data, $event)),
                                selected:  (data.warmupStage === null || data.warmupStage === undefined) ? 2 : _ctx.myOptions.find(option => option.name === data.warmupStage).id
                              }, null, 8, ["onChange", "selected"])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["field", "header", "hidden", "style"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["value"])
  ], 64))
}